import {
  UpdateIssuedItemAPIResponse,
  UpdateIssuedItemResponse,
  BaseReducerState,
} from '../../../services'
import { ActionTypes } from '../actions'

export type UpdateIssuedItemState = BaseReducerState & {
  data: UpdateIssuedItemResponse
}

const updateIssuedIteminitialState: UpdateIssuedItemState = {
  loading: false,
  success: false,
  message: '',
  data: null,
  error: null,
}

export const updateIssuedItems = (
  state: UpdateIssuedItemState = updateIssuedIteminitialState,
  action: { type: string; res: any }
): UpdateIssuedItemState => {
  switch (action.type) {
    case `${ActionTypes.UPDATE_ISSUED_ITEM}_REQUEST`:
      return {
        ...state,
        loading: true,
        success: false,
        message: null,
        data: null,
        error: null,
      }

    case `${ActionTypes.UPDATE_ISSUED_ITEM}_SUCCESS`: {
      const { success, data, message } = <UpdateIssuedItemAPIResponse>action.res
      return {
        ...state,
        loading: false,
        success,
        message,
        ...(success && data && { data }),
      }
    }
    case `${ActionTypes.UPDATE_ISSUED_ITEM}_FAILURE`:
      const res = <UpdateIssuedItemAPIResponse>action.res
      const { message } = res || {}
      res.error ??= message
      const { error } = res
      return {
        ...state,
        loading: false,
        success: false,
        message,
        error,
      }

    case `${ActionTypes.UPDATE_ISSUED_ITEM}_RESET`:
      return {
        ...state,
        loading: false,
        success: false,
        message: null,
        data: null,
        error: null,
      }
  }
  return state
}
